import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';


export default function FilterCustomerTrackerList(props) {
    //console.debug("RTS Break LoadListFilterTrackerList");

    const [isLoading, setIsLoading] = useState(true);
    
    const [trackers, setTrackers] = useState();
    const [repoTrackers, setRepoTrackers] = useState();


    useEffect(() => {
        if(props.trackers===null){
            setTrackers([]);
        }
        else{
            setTrackers(props.trackers);
        }

        if(props.data == null){
            setRepoTrackers([]);
        }
        else{
            setRepoTrackers(props.data);
        }

        setIsLoading(false);
    }, [props]);
    
    
    function valChange(e, val){
        props.setTrackersFx(val);
        setTrackers(val);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }
    

    return(
        <>
            <Autocomplete
                options={repoTrackers}
                renderInput={(params) => <TextField {...params} label="Trackers" size="small" />}
                value={trackers}
                onChange={valChange}
                multiple
            />
        </>
    );
}


